import { render, staticRenderFns } from "./ImportedProviders.vue?vue&type=template&id=69911452&"
import script from "./ImportedProviders.vue?vue&type=script&lang=js&"
export * from "./ImportedProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports